export const RULE = {
  EMAIL:
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  DATE: /^\d{4}-\d{2}-\d{2}/,
  TIME: /\d{2}:\d{2}:\d{2}/,
  SHORT_TIME: /^\d{2}:\d{2}$/,
  DATE_ONLY: /^\d{4}-\d{2}-\d{2}$/,
  TIME_ONLY: /^\d{2}:\d{2}:\d{2}$/,
  DATE_TIME: /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/,
  HIRAGANA: /^[ぁ-ん 　]*$/,
  HIRAGANA_AND_KATAKAN: /^[ぁ-んァ-ンー]*$/,
  ZIP_CODE: /^(\d{7}|\d{3}-\d{4})$/,
  HALF_WIDTH: /^[A-Za-z0-9!-/:-@[-`{-~]*$/,
  ALPHANUMERIC: /^[A-Za-z0-9]+$/,
  KANTAKANA: /^[ァ-ンー 　]*$/,
  NUMBER: /^[0-9０-９]*$/,
  PASSWORD: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/,
};
